exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\n  background: #fff;\n  padding: 32px 16px 12px;\n}\n.pagination-container.hidden[data-v-72233bcd] {\n  display: none;\n}\n", ""]);

// exports
